import { createFileRoute } from '@tanstack/react-router';

// Canonical Slide deep link. The segment only selects which Slide the layout
// route renders, so browser back and forward move between Slides.
export const Route = createFileRoute('/p/$shareId/s/$slidePublicId')({
  component: () => null,
});
